// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import DistinguishedFolderId from '../contract/DistinguishedFolderId';

export default function distinguishedFolderId(data: DistinguishedFolderId): DistinguishedFolderId {
    let result: DistinguishedFolderId = {
        __type: 'DistinguishedFolderId:#Exchange',
        ...data,
    };

    return result;
}
